"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MetadataList = void 0;
var tslib_1 = require("tslib");
// (C) 2022 GoodData Corporation
var react_1 = tslib_1.__importDefault(require("react"));
var isEmpty_1 = tslib_1.__importDefault(require("lodash/isEmpty"));
var Bubble_1 = require("../Bubble");
var ARROW_OFFSETS = {
    "cr cl": [13, 0],
    "cl cr": [-13, 0],
    "tc bc": [0, -13],
    "bc tc": [0, 13],
};
var ALIGN_POINTS = [{ align: "cr cl" }, { align: "tc bc" }, { align: "bc tc" }, { align: "cl cr" }];
/**
 * @internal
 */
exports.MetadataList = function (_a) {
    var title = _a.title, list = _a.list;
    return (react_1.default.createElement("div", { className: "gd-metadata-list" },
        title && react_1.default.createElement("div", { className: "gd-metadata-list-title" }, title), list === null || list === void 0 ? void 0 :
        list.map(function (element, index) { return (react_1.default.createElement("div", { className: "gd-metadata-list-element", key: index },
            react_1.default.createElement("span", { title: element.title }, element.title),
            !isEmpty_1.default(element.description) && (react_1.default.createElement(Bubble_1.BubbleHoverTrigger, { className: "gd-metadata-list-icon", showDelay: 0, hideDelay: 0 },
                react_1.default.createElement("div", { className: "gd-icon-circle-question" }),
                react_1.default.createElement(Bubble_1.Bubble, { className: "bubble-primary", arrowOffsets: ARROW_OFFSETS, alignPoints: ALIGN_POINTS }, element.description))))); })));
};
//# sourceMappingURL=MetadataList.js.map